import { useHistory } from "react-router";
import moment from "moment/moment";
import React, { useState } from "react";

import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { ALLOCATE_STUDENTS_TABLE_HEADERS as TABLE_HEADERS } from "../constant/allocate-students";
import AllocateStudentActions from "./AllocateStudentActions";
import ConfirmationDialog from "./ConfirmationDialog";
import MultiSelectFooter from "./MultiSelectFooter";
import NoRowsAllocation from "./NoRowsAllocation";
import CustomTooltip from "../../common/customTooltip/CustomTooltip";

const StudentList = ({
  rowsData,
  rowCount,
  page,
  onPageChange,
  allocateStudentHandler,
  availableForSelection,
  batchName,
  errMsg,
  pageSize,
  setPageSize,
}) => {
  const history = useHistory();

  const [openDialog, setOpenDialog] = useState(false);
  const [studentId, setStudentId] = useState();
  const [selectionModel, setSelectionModel] = useState([]);
  const [isMultiAllocate, setIsMultiAllocate] = useState(false);

  const isRowSelectable = (params) => {
    if (!params?.row?.isEligibleProgramActionForAllocation) {
      return false;
    } else {
      if (selectionModel.length >= availableForSelection) {
        if (selectionModel.includes(params.id)) return true;
        else return false;
      }
      return true;
    }
  };

  const StudentListHeader = [
    {
      field: "psid",
      headerName: TABLE_HEADERS.PSID,
      minWidth: 130,
      flex: 1,
      renderCell: (params) => (
        <strong
          className="color-primary cursor"
          onClick={() =>
            window.open(
              history.createHref({
                pathname: `admin/edp/studentDetails/${params?.value}`,
              }),
              "_blank"
            )
          }
        >
          {params.value}
        </strong>
      ),
    },
    {
      field: "applicationId",
      headerName: TABLE_HEADERS.APPLICATION_NO,
      minWidth: 150,
      flex: 1,
    },
    {
      field: "studentName",
      headerName: TABLE_HEADERS.STUDENT_NAME,
      minWidth: 200,
      flex: 1,
    },
    {
      field: "registrationDate",
      headerName: TABLE_HEADERS.REGISTRATION_DATE,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <span>
          {params?.value ? moment(params.value).format("DD-MM-YYYY") : "-"}
        </span>
      ),
    },
    {
      field: "termDispVal",
      headerName: TABLE_HEADERS?.TERM,
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => params?.value ?? "-",
    },
    {
      field: "courseId",
      headerName: TABLE_HEADERS.COURSE,
      minWidth: 150,
      flex: 1,
    },
    {
      field: "classes",
      headerName: TABLE_HEADERS.CLASS,
      minWidth: 100,
      flex: 1,
    },
    {
      field: "programAction",
      headerName: TABLE_HEADERS.PROGRAM_ACTION,
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <div className="d-flex gap-md">
          <span>{params?.value}</span>
          {params?.row?.programActionReason?.trim().length > 0 && ['TRIN', 'LEFT'].includes(params?.row?.programActionReason) && (
            <CustomTooltip
              showOnClick={false}
              title={'Ineligible for allocation: Student has an inactive status (TRIN/LEFT).'}
            >
              <div className="ellipsis-text-container">
                <span className="ms-2 cursor-pointer">
                  <i className="fa fa-eye" aria-hidden="true"></i>
                </span>
              </div>
            </CustomTooltip>
          )}
        </div>
      ),
    },
    {
      field: "studentGcId",
      headerName: "Google Classroom",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => <span>{params?.value ? "Yes" : "No"}</span>,
    },
    {
      field: "Actions",
      headerName: "Actions",
      type: "actions",
      minWidth: 150,
      flex: 1,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <AllocateStudentActions
          row={params.row}
          setOpenDialog={setOpenDialog}
          setId={setStudentId}
        />
      ),
    },
  ];

  const nextButtonHandler = (pageNum, updatedPageSize) => {
    if (pageSize !== updatedPageSize) {
      setPageSize(updatedPageSize);
      onPageChange(0, updatedPageSize);
    } else onPageChange(pageNum, updatedPageSize);
  };

  return (
    <div
      className="mt-3"
      style={{
        minHeight: 370,
        flexGrow: 1,
        display: "flex",
        flexFlow: "column",
      }}
    >
      <ADataGrid
        removeWrapperContainer
        rowCount={rowCount}
        rows={rowsData || []}
        columns={StudentListHeader}
        rowId={(row) => row.applicationId}
        rowHeight={44}
        nextButtonHandler={nextButtonHandler}
        paginationModel={{
          page: page,
          pageSize: pageSize,
        }}
        currentPage={page}
        columnMenu={""}
        loading={false}
        emptyRowPlaceholder={() => (
          <NoRowsAllocation errMsg={errMsg} batchName={batchName} />
        )}
        checkboxSelection={true}
        isRowSelectable={isRowSelectable}
        disableSelectionOnClick
        selectionModel={selectionModel}
        onSelectionModelChange={(newSelectionModel) => {
          if (newSelectionModel.length > availableForSelection) {
            setSelectionModel(
              newSelectionModel.slice(0, availableForSelection)
            );
            return;
          }
          setSelectionModel(newSelectionModel);
        }}
        hideFooterSelectedRowCount={true}
      />
      {selectionModel.length > 0 && (
        <MultiSelectFooter
          selectionModel={selectionModel}
          setSelectionModel={setSelectionModel}
          setIsMultiAllocate={setIsMultiAllocate}
          setOpenDialog={setOpenDialog}
        />
      )}
      <ConfirmationDialog
        open={openDialog}
        setOpen={setOpenDialog}
        id={studentId}
        allocateStudentHandler={allocateStudentHandler}
        isMulti={isMultiAllocate}
        selectionModel={selectionModel}
        setSelectionModel={setSelectionModel}
      />
    </div>
  );
};

export default StudentList;
